<!--
 * @Author: Shen Kui
 * @LastEditTime: 2022-11-30 10:10:21
 * @Description:
-->
<template>
  <div class="w-100 h-100" id="switch-list">
    <div class="w-100 h-100" v-if="showListData">
      <div class="list-content p-10">
        <el-row :gutter="10" type="flex" align="middle">
          <el-col :span="22">
            <el-input
              v-model="searchKey"
              placeholder="型号或名称搜索"
              clearable
              size="small"
            ></el-input>
          </el-col>
          <el-col :span="2" class="tr">
            <el-tooltip effect="dark" content="搜索" placement="top">
              <el-button
                type="primary"
                class="iconfont icon-search"
                @click="filterNodeList"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
        <div class="table-content m-t-10">
          <el-table
            :data="dataList"
            v-loading="tableLoading"
            class="w-100"
            height="100%"
            @select="selectionTableChange"
            ref="nodeTable"
          >
            <el-table-column type="selection" align="center" width="55"></el-table-column>
            <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
            <el-table-column label="开关名称" align="center" prop="name"></el-table-column>
            <el-table-column label="开关状态" align="center" prop="code.documentCode">
              <template #default="{row}">
                <span>{{ _.last(row.code.documentCode.split('_')) === 'on' ? '开' : '关' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="开关型号" align="center" prop="code.model"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="card-footer w-100 m-t-10 m-b-10">
        <el-row type="flex" align="middle" class="w-100">
          <el-col :span="12"
            ><el-button type="primary" size="mini" @click="addNode">新增</el-button></el-col
          >
          <el-col :span="12" class="tr"
            ><el-button type="primary" size="mini" @click="editNode">修改</el-button
            ><el-button type="primary" size="mini" @click="deleteNode">删除</el-button></el-col
          >
        </el-row>
      </div>
    </div>
    <div class="w-100 h-100" v-else>
      <div class="list-content p-10">
        <el-row :gutter="10" type="flex" align="middle">
          <el-col :span="4">
            <span class="fz-12">对象编号</span>
          </el-col>
          <el-col :span="20" class="tr">
            <el-input
              v-model="currentNodeName"
              placeholder="对象编号"
              clearable
              size="small"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10" type="flex" align="middle" class="m-t-10">
          <el-col :span="4">
            <span class="fz-12">开关状态</span>
          </el-col>
          <el-col :span="20" class="tr">
            <el-radio-group
              v-model="switchStatusSearch"
              @change="getDataList"
              class="d-flex flex-align-center"
            >
              <el-radio size="small" :label="'on'">开</el-radio>
              <el-radio size="small" :label="'off'">关</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row :gutter="10" type="flex" align="middle" class="m-t-10">
          <el-col :span="4">
            <span class="fz-12">仪器样式</span>
          </el-col>
          <el-col :span="18" class="tr">
            <el-input
              v-model="searchTypeKey"
              placeholder="名称搜索"
              clearable
              size="small"
            ></el-input>
          </el-col>
          <el-col :span="2" class="tr">
            <el-tooltip effect="dark" content="搜索" placement="top">
              <el-button
                type="primary"
                class="iconfont icon-search"
                @click="getDataList"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
        <div class="model-list m-t-10" v-loading="listLoading">
          <el-row>
            <el-col :span="8" v-for="(item, index) in deviceList" :key="index">
              <div class="w-100 model-item p-10 cur-pointer">
                <div class="w-100 item-img">
                  <img
                    class="w-100 h-100"
                    :src="`${currentEnv.VUE_APP_PLANT_SERVER}${item.thumbnails}`"
                    width="100%"
                    height="100%"
                    alt=""
                  />
                </div>
                <div
                  class="w-100 item-title ell tc"
                  @click="
                    (e) => {
                      e.stopPropagation()
                    }
                  "
                >
                  <el-checkbox
                    v-model="item.select"
                    @change="selectChange(item)"
                    class="text-color-white d-flex flex-align-center flex-row-center m-t-5"
                    >{{ item.name }}</el-checkbox
                  >
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="card-footer w-100 m-t-10">
        <el-row type="flex" align="middle">
          <el-col :span="9">
            <div
              @click="
                (e) => {
                  e.stopPropagation()
                }
              "
            >
              <el-radio-group v-model="addTypeValue" class="d-flex flex-align-center">
                <el-radio size="small" :label="1">锚点位置</el-radio>
                <el-radio size="small" :label="2">按节点</el-radio>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :span="8" class="p-l-5 p-r-5">
            <el-select
              v-model="nodePositionValue"
              placeholder="中心"
              size="mini"
              popper-class="document_select-popper"
            >
              <el-option
                v-for="item in nodePostionProp"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="7" class="tr"
            ><el-button size="mini" @click="cancleModify">取消</el-button>
            <el-button type="primary" size="mini" @click="loadInstrumentNode"
              >新增</el-button
            ></el-col
          >
        </el-row>
      </div>
    </div>
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'
import ApiMixinDocuments from '@/assets/js/api/documents'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import { isJSONObj, loadFbxModel, loadPrModel } from '../../../js/engineerSceneData'

const PlayerProgress = () => {
  return import('@/components/model/PlayerProgress')
}
export default {
  components: { PlayerProgress },
  name: 'SwitchList',
  data() {
    return {
      showLoadProgress: false,
      loadPercentage: 0,
      loadType: '',
      switchStatusSearch: 'on', // 开关状态查询
      listLoading: false,
      selectionNode: null,
      searchKey: '',
      currentNodeName: '', // 对象名称
      searchTypeKey: '', // 列表搜索
      showListData: true,
      dataList: [],
      orignList: [], // 原始数据
      deviceList: [],
      tableLoading: false,
      defaultFolderId: null, // 仪器的文件路径id
      templateAttrSetList: [],
      addTypeValue: 1, // 添加类型
      nodePositionValue: 'YN', // 节点位置
      nodePostionProp: [
        {
          value: 'Z',
          label: '上方',
        },
        {
          value: 'ZN',
          label: '下方',
        },
        {
          value: 'YN',
          label: '前方',
        },
        {
          value: 'Y',
          label: '后方',
        },
        {
          value: 'XN',
          label: '左方',
        },
        {
          value: 'X',
          label: '右方',
        },
      ],
      currentCreateParams: {}, // 新增模型的参数
      nodePosition: [],
    }
  },
  props: ['player', 'updateNode', 'watchNodeModify', 'currentNodeData'],
  mixins: [ApiMixinDocuments, ApiMixinDocumentList],
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || this.$store.getters['Sites/currentProject'] || {}
    },
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    DevicesLibrariesFolder() {
      const path = _.find(this.systemParams, { parameterCode: 'DevicesLibrariesFolder' }) || {}
      return path.parameterValue || null
    },
    DevicesClassId() {
      const parameter = _.find(this.systemParams, { parameterCode: 'DevicesClass' }) || {}
      return parameter ? parameter.parameterValue : ''
    },
  },
  watch: {
    updateNode() {
      this.getSwitchList()
    },
    watchNodeModify() {
      this.getSwitchList()
    },
    currentNodeData: {
      handler() {
        this.$nextTick(() => {
          this.getSwitchList()
        })
      },
      deep: true,
    },
  },
  async created() {
    this.getSwitchList()
    await this.getFolderClassId()
    // 获取属性模板
    await this.getAttributeTemplateList()
    // 获取仪器列表
    this.getDataList()
  },
  methods: {
    // 加载模型
    async createNode(data) {
      if (_.isEmpty(data.documentDataList)) {
        this.$message.warning('请选择设备进行添加')
        return
      }
      this.currentCreateParams = _.cloneDeep(data)
      if (this.currentCreateParams.positionType === 'anchor') {
        this.nodePosition = await this.player.Native.Camera.getAnchorPos()
      } else if (this.currentCreateParams.positionType === 'faceCenter') {
        if (this.currentNodeData.item) {
          const calcData = await this.player.Native.ModelTree.calcItemAabbData(
            this.currentNodeData.item
          )
          this.nodePosition = Aabb.faceCenter(calcData.aabb, this.currentCreateParams.faceValue)
        } else {
          this.$message.warning('请选择节点')
          return
        }
      }
      _.forEach(this.currentCreateParams.documentDataList, (item) => {
        this.getDocumentFileList(item)
      })
    },
    // 获取查找文档关联文件
    async getDocumentFileList(data) {
      const res = await DocumentManagementService.getFileList({
        id: data.id,
      })
      if (res && res.data) {
        this.checkModel(res.data)
      }
    },
    /**
     * @description: 检查是否模型是否存在 不存在则下载
     * @param {*}
     * @return {*}
     */
    async checkModel(modelParams) {
      const currentModelFile = _.find(modelParams, (item) => {
        return item.fileType === '.pr' || item.fileType === '.fbx'
      })
      if (!currentModelFile) {
        this.$message.error('当前项目没有模型')
        return
      }
      const currentZip = _.find(modelParams, ['fileType', '.zip'])
      if (currentZip) {
        this.checkModelMaterial(currentZip, currentModelFile)
      } else {
        this.getCurrentModelFile(currentModelFile, {})
      }
    },

    // 检查模型材质文件
    async checkModelMaterial(item, modelParams) {
      // eslint-disable-next-line no-await-in-loop
      const result = await this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      const exists = await this.player.Native.File.exists(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      if (item.md5 === result && exists) {
        this.getCurrentModelFile(modelParams, item)
      } else {
        this.downloadMaterialFile(item.md5, item, modelParams)
      }
    },

    // 检查模型是否存在
    getCurrentModelFile(item, materialParams) {
      this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
        (res) => {
          if (res === item.md5) {
            // 有模型就加载模型
            this.addModel(
              item.md5,
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
              item,
              materialParams
            )
          } else {
            // 校验md5失败
            this.downloadFile(item.md5, item.fileType, item, materialParams)
          }
        }
      )
    },

    // 下载材质文件
    async downloadMaterialFile(md5, item, modelParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMaterialMsg(modelParams.md5, item, modelParams)
      )
      const res = await this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` }
      )
      // 代表创建下载任务成功
      if (res) {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      } else {
        this.$message.warning('下载材质文件失败')
      }
    },

    /**
     * @description: 下载模型
     * @param {*} playerName：模型名称
     * @param {*} type： 模型类型
     * @return {*}
     */
    async downloadFile(md5, type, item, materialParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMsg(md5, item, type, materialParams)
      )
      this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` },
        (res) => {
          // 代表创建下载任务成功
          if (res) {
            this.showLoadProgress = true
            this.loadType = '下载中...'
          } else {
            this.$message.warning('下载模型失败')
          }
        }
      )
    },
    // 监听下载模型是否成功
    downloadMsg(md5, item, type, materialParams) {
      const that = this
      const fun = async (file, err) => {
        that.loadPercentage = 0
        that.showLoadProgress = false
        if (err) {
          that.$message.warning(`下载文件失败，${file}, ${err}`)
          return
        }
        if (
          file ===
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          // 检查当前md5和远程下载的md5是否一致
          that.player.Native.File.getFileMd5(
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
            (res) => {
              if (res !== md5) {
                that.$message.warning('当前请求的md5和服务器下载的md5不一致！')
              }
            }
          )
          that.addModel(md5, file, item, materialParams) // 模型下载成功就加载模型
        }
      }
      return fun
    },

    // 监听下载模型是否成功
    downloadMaterialMsg(md5, item, modelParams) {
      const that = this
      const fun = async (file, err) => {
        that.showLoadProgress = false
        that.loadPercentage = 0
        if (err) {
          that.$message.warning(`下载材质文件失败，${file}, ${err}`)
          return
        }
        if (
          file === `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}.zip`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          await this.player.Native.UiQt.decompressingZIP(file, '')
          setTimeout(() => {
            that.getCurrentModelFile(modelParams, item)
          }, 1500)
        }
      }
      return fun
    },

    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    checkModelLoad(data) {
      this.loadType = '加载中...'
      this.showLoadProgress = true
      this.loadPercentage = data * 100
    },
    /**
     * @description: 监听模型加载完成
     * @param {*} data
     * @return {*}
     */
    checkModelLoadEnd(data) {
      this.showLoadProgress = false
      this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 获取文档属性模板信息
    async getDocDetail(id) {
      const res = await DocumentManagementService.getDocumentEdite({
        id,
      })
      if (res && res.code === 0 && res.data) {
        if (!_.isEmpty(res.data.templateAttrSetList)) {
          const val = _.find(res.data.templateAttrSetList[0].attrValueList, (el) => {
            return el.fieldName === 'type'
          })
          return val ? val.attrValue : ''
        }
      }
      return ''
    },
    // 加载模型
    async addModel(md5, url, item, materialParams) {
      this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      const modelName = await this.getDocDetail(item.documentId)
      const rootItems = await this.player.Native.ModelTree.getRootItems()
      const currentRoot = _.find(rootItems, (val) => {
        return val.code && JSON.parse(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const rootNode =
        !_.isNil(currentRoot) && currentRoot.nodePtr
          ? currentRoot.nodePtr
          : await this.player.Native.NodeProxy.rootNode()
      let parentNode = this.currentNodeData.nodePtr ? this.currentNodeData.nodePtr : rootNode
      if (this.currentCreateParams.modifyNode && this.currentCreateParams.modifyNode.nodePtr) {
        const editNode = await this.player.Native.NodeEditor.node()
        if (editNode === this.currentCreateParams.modifyNode.nodePtr) {
          await this.player.Native.NodeEditor.setNode(0)
        }
        await this.player.Native.NodeProxy.destroyNode(this.currentCreateParams.modifyNode.nodePtr)
        if (this.currentNodeData.nodePtr === this.currentCreateParams.modifyNode.nodePtr) {
          parentNode = this.currentCreateParams.modifyNode.parentPtr
        }
      }
      let currentNode = null
      if (item.fileType === '.pr') {
        currentNode = await loadPrModel(
          url,
          this.currentCreateParams.name || item.documentName,
          parentNode,
          this.player
        ) // 加载模型
      } else if (item.fileType === '.fbx') {
        currentNode = await loadFbxModel(
          url,
          this.currentCreateParams.name || item.documentName,
          parentNode,
          this.player
        )
      } else {
        currentNode = await this.player.Native.NodeProxy.loadModelNode(
          parentNode,
          url,
          this.currentCreateParams.name || item.documentName
        ) // 加载模型
      }
      await this.player.Native.NodeProxy.setGlobalTranslation(currentNode, this.nodePosition)
      await this.player.Native.NodeProxy.setNodeInfo(currentNode, {
        code: JSON.stringify({
          type: this.currentCreateParams.type,
          fileType: item.fileType,
          filePath: url,
          documentId: item.documentId,
          documentName: item.documentName,
          documentCode: item.documentCode,
          md5,
          materialFileMd5: materialParams.md5,
          model: modelName,
        }),
      })
      this.$emit('updateEditTree', currentNode)
      this.getSwitchList()
    },
    // 表格选择
    selectionTableChange(selections, row) {
      this.$refs.nodeTable.clearSelection()
      this.selectionNode = row
      this.$refs.nodeTable.toggleRowSelection(row, true)
    },
    // 表格筛选
    filterNodeList() {
      this.dataList = _.filter(this.orignList, (item) => {
        return item.name.search(this.searchKey) >= 0 || item.code.model.search(this.searchKey) >= 0
      })
    },
    // 选择模型切换
    selectChange(data) {
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      data.select = true
    },
    // 获取仪器列表
    async getSwitchList() {
      // 获取当前选中模型子级
      const subNodes = await this.player.Native.NodeProxy.getNodeChildren(
        this.currentNodeData.nodePtr
      )
      const filterList = _.filter(subNodes, (val) => {
        return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Switch'
      })
      this.orignList = _.map(filterList, (el) => {
        return {
          code: JSON.parse(el.code),
          id: el.id,
          item: el.item,
          name: el.name,
          nodePtr: el.nodePtr,
          parentPtr: el.parentPtr,
          type: el.type,
        }
      })
      this.dataList = _.cloneDeep(this.orignList)
    },
    // 加载仪器模型节点
    async loadInstrumentNode() {
      const isSelectList = _.filter(this.deviceList, ['select', true])
      const params = {
        modifyNode: this.selectionNode,
        documentDataList: isSelectList,
        type: 'Switch',
        name: this.currentNodeName,
        positionType: this.addTypeValue === 1 ? 'anchor' : 'faceCenter',
        faceValue: this.nodePositionValue,
      }
      this.createNode(params)
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      this.currentNodeName = ''
    },
    // 获取仪器的文件路径id
    async getFolderClassId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '开关',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '开关'
          })
          if (currentFolder) {
            this.defaultFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取属性模板
    async getAttributeTemplateList() {
      const res = await DocumentManagementService.getTemplateByClassId({
        classId: this.DevicesClassId,
      })
      if (res && res.code === 0 && res.data) {
        if (res.data.templateAttrSetList) {
          this.templateAttrSetList = _.cloneDeep(res.data.templateAttrSetList)
        }
      }
    },
    // 获取仪器列表
    async getDataList() {
      if (this.defaultFolderId) {
        this.listLoading = true
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: this.defaultFolderId,
          isRecursion: true,
          keyWord: this.searchTypeKey,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          startTime: '',
        }
        // // 拼接属性模板搜索条件
        // if (this.templateAttrSetList) {
        //   const attrValue = _.find(this.templateAttrSetList[0].attrValueList, (item) => {
        //     return item.attrbuteDetail.displayName === '型号'
        //   })
        //   query.searchItems = [
        //     {
        //       tableName: this.templateAttrSetList[0].tableName,
        //       tableItems: [
        //         {
        //           fieldName: attrValue.fieldName,
        //           fieldValue: this.searchTypeKey,
        //           valueType: attrValue.valueType,
        //         },
        //       ],
        //     },
        //   ]
        // }
        const res = await DocumentManagementService.advancedSearch(query)
        this.listLoading = false
        if (res && res.code === 0 && res.data) {
          const currentList = _.filter(res.data.items, (item) => {
            return _.last(item.code.split('_')) === this.switchStatusSearch
          })
          this.deviceList = _.map(currentList, (item) => {
            return {
              ...item,
              select: false,
            }
          })
        }
      }
    },
    // 取消编辑
    cancleModify() {
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      this.selectionNode = null
      this.showListData = true
      this.currentNodeName = ''
      setTimeout(() => {
        this.getSwitchList()
        this.$refs.nodeTable.clearSelection()
      }, 500)
    },
    // 去到新增页面
    addNode() {
      this.showListData = false
    },
    // 去到编辑
    editNode() {
      if (!this.selectionNode) {
        this.$message.warning('请选择模型修改模型')
        return
      }
      _.forEach(this.deviceList, (item) => {
        if (item.id === this.selectionNode.code.documentId) {
          item.select = true
        }
      })
      this.currentNodeName = this.selectionNode.name
      this.showListData = false
    },
    // 删除节点
    async deleteNode() {
      if (!this.selectionNode) {
        this.$message.warning('请选择需要删除的模型')
        return
      }
      if (this.selectionNode.nodePtr) {
        const editNode = await this.player.Native.NodeEditor.node()
        if (editNode === this.selectionNode.nodePtr) {
          await this.player.Native.NodeEditor.setNode(0)
        }
        await this.player.Native.NodeProxy.destroyNode(this.selectionNode.nodePtr)
        this.selectionNode = null
        this.$refs.nodeTable.clearSelection()
        this.getSwitchList()
        this.$emit('updateEditTree', '')
      }
    },
  },
}
</script>
<style lang="scss">

@import '../../../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../../../css/index.scss';
/deep/.player_progress {
  position: fixed !important;
}
/deep/ .el-table__header-wrapper .el-checkbox {
  display: none !important;
}
/deep/.el-checkbox__label {
  font-size: 12px !important;
  max-width: 80px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#switch-list {
  color: #fff;
  z-index: 99;
  background-color: transparent;
  .list-content {
    height: calc(100% - 48px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    .table-content {
      height: calc(100% - 42px);
    }
    .model-list {
      height: calc(100% - 120px);
      overflow-y: auto;
      .model-item {
        height: 160px;
        .item-img {
          height: calc(100% - 30px);
          background-color: #383b3b !important;
        }
        .item-title {
          height: 30px;
          line-height: 30px;
        }
      }
      .model-item:hover {
        background-color: rgba(46, 107, 176, 0.5) !important;
      }
    }
  }
  .card-footer {
    border: none !important;
  }
}

</style>
